import PropTypes from 'prop-types';

const topicProps = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  reads: PropTypes.number,
  views: PropTypes.number,
  hierarchy: PropTypes.arrayOf(PropTypes.string),
  posts: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.shape({
      totalCount: PropTypes.number.isRequired,
    }),
  ]),
  ancestors: PropTypes.arrayOf(PropTypes.object),
  score: PropTypes.number,
  privacy: PropTypes.string,
  memberEditable: PropTypes.string,
};

const TopicShape = PropTypes.shape(topicProps);
topicProps.childTopics = PropTypes.arrayOf(TopicShape);

export default TopicShape;
